import type { IAssignmentState } from './types';

export const state: IAssignmentState = {
  content: null,
  schedule: [],
  answers: {},
  isStart: false,
  isFinish: false,
};
